import { useEffect, useState } from "react";

function getDarkModeSetting(): boolean {
  try {
    const darkModeSetting = localStorage.getItem("darkMode");
    if (darkModeSetting !== null) {
      return JSON.parse(darkModeSetting);
    }
  } catch {
    // Corrupted value - remove it so it doesn't keep crashing
    try { localStorage.removeItem("darkMode"); } catch { /* best-effort */ }
  }
  // Check if user's system preference is for dark mode
  const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDarkMode;
}

export const useDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(getDarkModeSetting());

  useEffect(() => {
    if (isDarkMode) {
      document.querySelector("body")!.setAttribute("data-theme", "dark");
      localStorage.setItem("darkMode", JSON.stringify(true));
    } else {
      document.querySelector("body")!.setAttribute("data-theme", "light");
      localStorage.setItem("darkMode", JSON.stringify(false));
    }
  }, [isDarkMode]);

  return { isDarkMode, setIsDarkMode };
};
